type TabType = "open" | "draft" | "reviewed" | "rejected" | "closed";

type Props = {
  active: TabType;
  setActive: (value: TabType) => void;
   lang: "en" | "id";
  counts: { [key in TabType]: number };
};

const TAB_LABELS: Record<TabType, { en: string; id: string }> = {
  draft: { en: "Draft", id: "Draft" },
  "reviewed": { en: "In Review", id: "Sedang Ditinjau" },
  open: { en: "Open", id: "Dibuka" },
  closed: { en: "Closed", id: "Ditutup" },
  rejected: { en: "Rejected", id: "Ditolak" },
};

const TAB_LIST: { label: string; value: TabType }[] = [
  { label: "Draft", value: "draft" },
  { label: "In Review", value: "reviewed" },
  { label: "Open", value: "open" },
  { label: "Closed", value: "closed" },
  { label: "Rejected", value: "rejected" },
];

export default function AdminJobTabs({ active, setActive, counts, lang }: Props) {
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-6 border-b border-black mt-6 pb-2 w-max">
        {TAB_LIST.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActive(tab.value)}
            className={`pb-2 border-b-2 whitespace-nowrap ${
              active === tab.value
                ? "border-primary text-primary font-semibold"
                : "border-transparent text-gray-500 hover:text-primary"
            }`}
          >
            {TAB_LABELS[tab.value][lang]}{" "}
            <span className="text-primary">({counts[tab.value] || 0})</span>
          </button>
        ))}
      </div>
    </div>
  );
}

